import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "label-group" }
const _hoisted_2 = { class: "label-container" }
const _hoisted_3 = { class: "index-label-text-container" }
const _hoisted_4 = { class: "label-title" }
const _hoisted_5 = { class: "label-value" }
const _hoisted_6 = { class: "label-text-container" }
const _hoisted_7 = { class: "label-title" }
const _hoisted_8 = { class: "label-value" }

import { useStore } from 'vuex';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ChartLabels',
  props: {
  reportId: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const store = useStore();
const getReportLabels = (reportId: string) => computed(() => store.getters.getReportLabels(reportId));

const reportLabels = computed(() => getReportLabels(props.reportId).value);
const labels = computed(() => {
  if (reportLabels.value) {
    return reportLabels.value.reverse ? reportLabels.value.labels.slice().reverse() : reportLabels.value.labels;
  }
  return [];
});

const scaleTitle = computed(() => reportLabels.value?.scaleTitle || '-');
const scaleValue = computed(() => reportLabels.value?.scaleValue || '-');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(scaleTitle.value), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(scaleValue.value), 1)
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(labels.value, (label) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "label-container",
        key: label.label
      }, [
        _createElementVNode("div", {
          class: "label-color",
          style: _normalizeStyle({ 'background-color': label.borderColour })
        }, null, 4),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(label.label), 1),
          _createElementVNode("span", _hoisted_8, _toDisplayString(label.value), 1)
        ])
      ]))
    }), 128))
  ]))
}
}

})